export const Reconn_Deck_with_Reconn_Deck_Bars_Staging = "B9A4DCA1-4AA0-4F13-A54D-C8AFD6A0D1D4";
export const Reconn_Deck_with_Vortex_Bars_Staging = "832892E4-8DE8-493F-BA23-1DA3F9E32829";
export const Reconn_Deck_with_NS_Bars_Staging = "75571A06-317A-4D6F-80D8-062E5266619B";
export const Reconn_Deck_with_Pioneer_Staging = "56730CF6-4B44-4B5C-832A-1C034183C8CA";


export const Reconn_Deck_with_Vortex_Bars = "880C1E22-31DD-4AEF-B0AC-269279CD3984";
export const Reconn_Deck_with_Reconn_Deck_Bars = "9DAE2B8A-A943-4F24-9F86-C273B4A7AD16";
export const Reconn_Deck_with_NS_Bars = "357BBB4C-D608-4425-98B2-E92B90228D64";
export const Reconn_Deck_with_Pioneer = "C7961B39-2FF4-48EB-AED1-32E04B6B1632";